import { OverlayInteraction, OverlayStatus } from '../types/tracking';
import { dispatchTrackingEventGA4 } from './dispatchTrackingEventGA4';

export const enum ArrowDirection {
  Previous = 'previous',
  Next = 'next',
}

export type GalleryTrackingProps = {
  isOverlayOpen: boolean;
  productGalleryV2?: boolean;
};

export type TabGalleryTracking = {
  galleryTabs: Array<{ id: string }>;
  productGalleryV2: boolean;
  isOverlayOpen: boolean;
  model3D: { path: string } | null;
};

export const dispatchTabGalleryView = ({
  galleryTabs,
  productGalleryV2,
  isOverlayOpen,
  model3D,
}: TabGalleryTracking) => {
  if (productGalleryV2) {
    const has3DButton = Boolean(model3D);
    const listItems = [...galleryTabs.map(tab => tab.id), ...(has3DButton ? ['3D'] : [])];

    dispatchTrackingEventGA4({
      event: 'product-gallery_view',
      element: 'tab gallery',
      overlay: isOverlayOpen ? OverlayStatus.Open : OverlayStatus.Closed,
      list_items: listItems,
      list_length: listItems.length,
    });
  }
};

export const dispatchArrowButtonClick = (
  direction: ArrowDirection,
  trackingProps?: GalleryTrackingProps
) => {
  if (trackingProps?.productGalleryV2) {
    dispatchTrackingEventGA4({
      event: 'product-gallery_click',
      element: 'arrow button',
      button_text: direction,
      overlay: trackingProps.isOverlayOpen ? OverlayStatus.Open : OverlayStatus.Closed,
      interaction: OverlayInteraction.Slide,
    });
  }
};
